// Copy of the "Machines" walkthrough. The rules every text follows are in ../../de/help.js.
// Tab and field names are written as the machine page shows them (../machine.js).
// Twin file: help/materials.js. A change here nearly always belongs there too.
export default {
  title: "Machines",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    MachineOverview: "Overview",
    MachineDetail: "Machine",
    CustomerDetail: "Customer prices",
    PacketDetail: "Packet",
    ProjectDetail: "Project",
    ProjectCostsForOne: "Project costs",
  },
  related: "Connections",
  step: {
    list: {
      text: "This is your company's machine fleet. A click on a row opens that machine.",
    },
    row: {
      text: "A row shows the name, the purchase price per unit and when the machine was last changed.",
    },
    create: {
      text: "Create new offers both: create new machine opens the empty form. It needs a name and a unit.",
    },
    "kind-filter": {
      text: "Machines and packets share one table, and the filter above it shows just one of the two. A packet bundles several machines for a project or a customer.",
    },
    head: {
      text: "The head carries the machine's icon and its name. The actions for this record sit on the right.",
    },
    "action-duplicate": {
      text: "Duplicate opens a new machine with the same details and prices. You change only what differs and save.",
    },
    "action-packet": {
      text: "Create packet from this starts a new packet. This machine is already its first position.",
    },
    tabs: {
      text: "The tabs divide the page up. Which tab is open is part of the page's address.",
    },
    base: {
      text: "Name, billing unit and transport weight are the master data. The unit is hour or day; the transport weight picks the rental supplier's transport class.",
    },
    purchase: {
      text: "The purchase price is per unit. If you pay different suppliers different amounts, add several named purchase prices; one of them is the default. Each price picks its own currency, and a project only costs the price in its own currency.",
    },
    note: {
      text: "The note is for an internal remark. It belongs to the machine, not to a single project.",
    },
    // The Purchasing tab, once purchase prices belong to suppliers (docs/suppliers.md).
    "purchase-tab": {
      text: "The Purchasing tab lists every supplier this machine can be had from. You change their prices at the supplier, in its assortment.",
    },
    "purchase-history": {
      text: "The head says what the machine usually costs: the default supplier's price and the range across all. Opened, the price history shows every price over the months, right of Today those already set.",
    },
    "purchase-rows": {
      text: "Each supplier shows today's price and, where already set, the next one. Difference measures it against the default, and the name opens the supplier's assortment.",
    },
    // A row in another unit than the machine (Mietpark Nord per week).
    "purchase-unit": {
      text: "A supplier may bill per week or month even when the machine is sold per hour. The price names its unit; Difference compares day, week and month per day, an hour only with hours.",
    },
    // The line under Mietpark Nord: its transport tariff in the Minibagger's class.
    "purchase-transport": {
      text: "Below is the supplier's transport in the class the machine's transport weight picks. The tariff is kept in its terms.",
    },
    "purchase-accessories": {
      text: "Below it the accessories the supplier rents out with this machine, such as a bucket, priced per day or week. You add a new one in the row's ⋮ menu; on a rental in the project you take it along.",
    },
    "purchase-default": {
      text: "The default is the price a project takes the machine over with. A click on another supplier makes it the default, at once and without saving.",
    },
    "purchase-change": {
      text: "The pencil changes a supplier's price: the new amount and the day it applies from, back-dated too. The old price stays in the history.",
    },
    "purchase-quantity": {
      text: "With a quantity to compare at, here a duration, the Delivered column works in discount and early payment discount; transport comes on top. The cheapest is bold and green, even when its list price is higher.",
    },
    "purchase-add": {
      text: "Add price takes on another supplier's price. The first one becomes the default.",
    },
    "purchase-following": {
      text: "After a backdated change, the projects' bookings stay at the old price. Update puts them on the price of their day.",
    },
    files: {
      text: "File storage is for manuals and inspection records. A due date changes colour as it comes closer.",
    },
    activity: {
      text: "Activity shows every change with its day and who made it. Under References you see where this machine is used.",
    },
    save: {
      text: "Save writes every tab at once. A tab with an error in it is brought to the front.",
    },
    comparison: {
      text: "Actions, then Compare, sets two machines side by side. The rows are the suppliers that rent out both. The cheaper price is bold and green.",
    },
    "comparison-pick": {
      text: "At the top of each card you choose the machine. Below, its usual price and at how many suppliers it is the cheaper one.",
    },
    "comparison-only": {
      text: "Suppliers that have only one of the two are folded under its card.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Setup: what a machine does outside the catalogue.
    "customer-price": {
      text: "For one customer you set a selling price of its own. A fixed price may apply per day even when the machine costs per hour.",
    },
    "packet-items": {
      text: "A packet bundles several machines. A project or a customer takes them all over in one step.",
    },
    "project-machines": {
      text: "A project holds the selling price beside the purchase price. Cost and revenue each convert the time of use into their own unit.",
    },
    "project-report": {
      text: "A machine is booked on the Machines tab of [[hwr:a/an]] [[hwr]], one line per device, with its device number and hours. A day rate counts every started day of use.",
    },
    "project-costs": {
      text: "A project's cost structure shows what share of its cost is machines. Every booked usage is valued at the purchase price fixed when its report was saved.",
    },
  },
}
